import React, { useEffect } from 'react';
import { Button, Milestones, Sidebar, useQueryParams } from '@insurancemenu/imenu-components-lib';
import { MilestoneStatuses } from '@insurancemenu/imenu-components-lib/dist/types';
import { useHistory, useParams } from 'react-router-dom';
import { ChecklistButtonStateText, ChecklistOption, RFQChecklistCard } from 'types/enrollmentService';
import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { MilestoneItemType } from '@insurancemenu/imenu-components-lib/dist/types/Milestones';
import { toJS } from 'mobx';
import { RFQ_PROPOSAL_CARD_DATA } from 'global/checklists-helpers/RFQProposalChecklistHelper';
import { createStyles } from './styles';

// TODO re-write with styled components and new store approach
const RFQProposalSidebar = observer((): JSX.Element => {
  // Mobx store
  const {
    rfqProposalSidebarStore: { checklist, group, cart, getRFQProposalSidebarInfo, resetSidebarInfo },
  } = useRootStore();

  const convertedChecklist = toJS(checklist);
  const convertedGroup = toJS(group);
  const convertedCart = toJS(cart);

  const bc = convertedCart?.lastUpdateBrowsingCriteria;
  const classes = createStyles();

  // Query parameters
  const query = useQueryParams();
  const cartId = query.get('cartId') || '';

  const { periodId } = useParams<{ periodId?: string }>();

  const history = useHistory();

  useEffect(() => {
    void getRFQProposalSidebarInfo(cartId, periodId || '');
    return resetSidebarInfo;
  }, []);

  const calculateMilestoneStatus = (option: ChecklistOption<RFQChecklistCard>): MilestoneStatuses => {
    switch (option.buttonState) {
      case ChecklistButtonStateText.VIEW_EDIT:
      case ChecklistButtonStateText.VIEW:
        return MilestoneStatuses.COMPLETED;
      case ChecklistButtonStateText.UNAVAILABLE:
        return MilestoneStatuses.INACTIVE;
      case ChecklistButtonStateText.CONTINUE:
        return MilestoneStatuses.ACTIVE;
      default:
        return MilestoneStatuses.INACTIVE;
    }
  };

  const MilestonesOptions = (): MilestoneItemType[] => {
    if (convertedChecklist) {
      const checklistOptions = convertedChecklist?.checklistOptions;
      const milestoneStatuses = checklistOptions.map((option) => ({
        label: RFQ_PROPOSAL_CARD_DATA[option.card].title,
        status: calculateMilestoneStatus(option),
      }));
      return milestoneStatuses;
    }
    return [];
  };

  const onRedirectClick = (): void => {
    history.push(`/group/${convertedGroup?.id}`);
  };

  return (
    <Sidebar className={classes.groupSidebar}>
      <section className={classes.groupInfoSection}>
        {convertedGroup && (
          <>
            <h2 className={classes.groupTitle}>{convertedGroup?.name}</h2>
            <Button type="text" className={classes.viewProfileLink} size="medium" onClick={onRedirectClick}>
              (View Group Profile)
            </Button>
          </>
        )}
        <h3 className={classes.effectiveDateTitle}>Effective Date</h3>
        <p className={classes.infoText}>
          {bc?.effectiveDate && dateFormatters.normDateToShortAmericanDate(bc.effectiveDate)}
        </p>
        {cartId && (
          <>
            <h3 className={classes.addressTitle}>Location</h3>
            <p className={classes.infoText}>{bc && `${bc.county}, ${bc.state} ${bc.zipCode}`}</p>
          </>
        )}
      </section>
      <section className={classes.milestones}>
        <Milestones milestones={MilestonesOptions()} allConnectingLinesWidth="4rem" />
      </section>
    </Sidebar>
  );
});

export default RFQProposalSidebar;
